import { defineStore } from "pinia";

export const useLoaderStore = defineStore("loader", {
  state: () => ({ isLoading: false }),
  actions: {
    setIsLoading(value) {
      this.isLoading = value;
    },
  },
});
